import api from "../apiInstance";
import { BackgroundModel, BackgroundPublicModel, CreateBackgroundModel, UpdateBackgroundModel } from "./interfaces/Background";

export const initializeBackground = async (data: CreateBackgroundModel): Promise<BackgroundModel> => {
    const res = await api.post<BackgroundModel>(process.env.REACT_APP_RENTIC_API_URL! + '/background/initialize', data);

    return res.data;
}

export const getBackground = async (): Promise<BackgroundModel> => {
    const res = await api.get<BackgroundModel>(process.env.REACT_APP_RENTIC_API_URL! + '/background');

    return res.data;
}

export const getBackgroundPublic = async (): Promise<BackgroundPublicModel | null> => {
    const res = await api.get<BackgroundPublicModel | null>(process.env.REACT_APP_RENTIC_API_URL! + '/background/public');

    return res.data;
}

export const updateBackground = async (data: UpdateBackgroundModel): Promise<boolean> => {
    const res = await api.patch<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/background', data);

    return res.data;
}

export const deleteBackgroundPic = async (): Promise<boolean> => {
    const res = await api.delete<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/files/delete_background_pic');

    return res.data;
}

export const deleteBackground = async (): Promise<boolean> => {
    const res = await api.delete<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/background');

    return res.data;
}

